import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';
import { Divider, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import * as React from 'react';
import LineItemForm from './LineItemForm';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: '80vh',
  width: '50vw',
  bgcolor: 'background.paper',
  borderRadius: '15px',
  boxShadow: 24,
  display: 'flex',
  flexDirection: 'column',
};

const ItemFormModel = ({
  open,
  handleClose,
  handleSubmit,
  initialData = null,
  edit = false,
  readOnly = false,
  invoiceTypeCode,
  profileExecutionId,
  externalFieldErrors = {},
  restrictToRcm = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
      className="backdrop-model"
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 2,
              py: 2,
              borderBottom: '1px solid #e0e0e0',
            }}
          >
            <Typography variant="h6" sx={{ ml: '1.5rem' }}>
              {!edit && 'New'}Line Item
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider />
          <LineItemForm
            submitForm={handleSubmit}
            handleClose={handleClose}
            defaultState={initialData}
            edit={edit}
            readOnly={readOnly}
            invoiceTypeCode={invoiceTypeCode}
            profileExecutionId={profileExecutionId}
            externalFieldErrors={externalFieldErrors}
            restrictToRcm={restrictToRcm}
          />
        </Box>
      </Fade>
    </Modal>
  );
};
export default ItemFormModel;
